module.exports = __webpack_public_path__ + "static/media/bellhop.ec54d535.svg";